export default "__VITE_ASSET__DjF3Bly7__"